<template>
    <div>
        <with-e-mail-login v-if="selected==='login'" @navigate="navigate"></with-e-mail-login>
        <!--<with-e-mail-sign-up v-if="selected==='signup'" @navigate="navigate"></with-e-mail-sign-up>-->
        <with-e-mail-reset-p-w v-if="selected==='resetPW'" @navigate="navigate"></with-e-mail-reset-p-w>
    </div>
</template>

<script>
    import WithEMailLogin from "./withEMailLogin";
    //import WithEMailSignUp from "./withEMailSignUp";
    import WithEMailResetPW from "./withEMailResetPW";

    export default {
        components: {
            WithEMailResetPW,
            //WithEMailSignUp,
            WithEMailLogin},
        name: "with-e-mail",
        data: () => ({
            selected: "login"
        }),
        created () {
            if ( this.$route.query.action && this.$route.query.action !== 'resetPW' ) { this.navigateReset() }
            if ( this.$route.query.action === 'resetPW' ) { this.selected = 'resetPW' }
        },
        methods: {
            navigate(action) { // navigate to subscreen
                let query = Object.assign({}, this.$route.query);
                query.action = action;
                this.$router.push({ query });
            },
            navigateReset() { // reset navigation after F5 refresh
                let query = Object.assign({}, this.$route.query);
                delete query.action;
                this.$router.replace({ query });
            }
        },
        watch: {
            '$route.query.action' (to, from) {
                this.selected = to === undefined && from ? "login" : to;
            }
        }
    }
</script>

<style scoped>

</style>